import React from 'react';

import {
  InactiveCustomerBanner,
  useInactiveCustomerBanner,
} from 'src/app/banner/InactiveCustomerBanner';
import { NavBar } from 'src/common/NavBar';

export function Layout({ children }: { children: React.ReactNode }) {
  const shouldUseInactiveBanner = useInactiveCustomerBanner();

  return (
    <div className="flex flex-col gap-1">
      <NavBar />
      {shouldUseInactiveBanner ? <InactiveCustomerBanner /> : children}
    </div>
  );
}
